export default __webpack_public_path__ + "static/Poppins-Regular.woff2";